<template>
      <el-dialog :width="dialogWidth" title="Edit note" :visible.sync="dialogFormVisible" @close="CloseEditLogForm()" :modalAppendToBody="false">
        <div>
          <el-form :model="form" ref="form" :rules="rules" @validate="validate">
            <div id="EditLogForm">
              <!-- <el-row>
                            <el-col cols="12" md="3">
                              <h5>Assign Technician</h5>
                              <v-text-field
                                v-model="form.userassigned"
                                placeholder="ex: This feature is a WIP"
                                required
                              ></v-text-field>
                            </el-col>
              </el-row>-->

              <h5>Notes</h5>
                      <el-form-item prop="note">
                        <el-input
                        class="tst-edit-note-text"
                          type="textarea"
                          :rows="4"
                          placeholder="ex: The boiler displays a blinking red light on power on"
                          v-model="form.note"
                          required
                        ></el-input>
                      </el-form-item>
              <h4>current images</h4>
              <div v-for="(image,index) of this.form.imageurl" :key="index" style="position: relative;">
                <!-- <div v-if="imageurlmarkedfordeletion == true">
                  <h3>images will only be deleted when image update is submitted</h3>
                </div>-->

                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="markImageForDeletion(index)"
                  style="position: absolute; top: 0; right: 0;"
                ></el-button>
                <img class="imagecontainer" :src="image" label="current image" />
              </div>

              <PictureUpload
                v-on:picture-id="handlePictureid($event)"
                v-on:displaypicturelocally="handlePictureLocally($event)"
                v-on:removePictureId="RemovePictureIdLocally($event)"
                :propertyid = "this.propertyid"
              />
            </div>

            <el-button class="tst-confirm-update-note" type="success" text @click.once="updateLog(log.logid)">Update Note</el-button>
            <el-button class="tst-cancel-update-note" text @click="CloseEditLogForm()">Cancel</el-button>
        </el-form>

      </div>
  </el-dialog>
</template>

<script>
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadMulti.vue";

import { mapState } from "vuex";
export default {
  props: {
    log: Object,
    propertyid: String
  },
  components: {
    PictureUpload
  },
  data() {
    return {
      dialogFormVisible: true,
      dialog: false,
      dialogWidth:"50%",
      picsToAdd: [],
      form: {
        // issuetitle: this.issue.issuetitle,
        logtype: this.log.logtype,
        userassigned: this.log.userassigned,
        machineid: this.$route.params.MachineId,
        userid: this.log.userid,
        userspicurl: this.log.userspicurl,
        note: this.log.note,
        files: this.log.files,
        imageurl: this.log.imageurl,
        pictureid: this.log.pictureid,
        logid: this.log.logid,
        logdate: this.log.logdate,
        firstname: this.log.firstname,
        lastname: this.log.lastname
      },
      imageurlmarkedfordeletion: false,
      inputRules: [v => (v && v.length != 0) || "This field is required"],
       rules: {
          note: [
            { required: true, message: 'Note cannot be empty', trigger: 'blur' },
          ],
       },
       invalid: Boolean
    };
  },
  mounted(){
  var x = window.matchMedia("(max-width: 979px)");
        if (x.matches) {
        this.dialogWidth = "100%"
         }
  },
  created() {
    this.form.userid = this.user.userid;
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  }, 
  methods: {

    validate(){
      if(this.form.imageurl.length > 0){
            this.$refs["form"].clearValidate()
      }
    },
    handlePictureid($event) {
      this.form.pictureid.push($event.pictureid);
    },
    handlePictureLocally($event) {
     // this.form.imageurl.unshift($event);
     this.picsToAdd.push($event);
     
     //remove warning "note cannot be empty" when picture is added
      this.$refs["form"].clearValidate()

    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
    },
    markImageForDeletion(index) {
      this.imageurlmarkedfordeletion = true;
      console.log("this is the index passed in " + index);
      // this.form.imageurl.splice(index, 1);
      this.form.pictureid.splice(index, 1);
      this.$delete(this.form.pictureid, index);
      this.$delete(this.form.imageurl, index);
    },
    updateLog() {

     this.$refs["form"].validate((valid) => {
       console.log
          if (valid || this.form.imageurl.length > 0 ) {

            } else {
            this.invalid = true;
            return false;
          }
        });
        if(this.invalid == true){
          this.invalid = false;
          return;
        }

      this.form.imageurl = this.form.imageurl.concat(this.picsToAdd); 

      console.log("form is valid and submitted successfully", this.form);
      EventService.updateLog(this.log.logid, this.form)
        .then(() => {
           let updatelogpackage = [this.log, this.form];
           this.$emit("updated-log", updatelogpackage);
 
           this.$store.dispatch("addNotification", {
                       type: "success",
                       Message: "Note Updated"
                     });
 
           this.CloseEditLogForm();
        })
        .catch(error => {
            console.log(error);
            
            this.CloseEditLogForm();
        });
    },
    CloseEditLogForm(log) {
      this.$emit("close-EditLogForm");
      this.dialogFormVisible = false;
    }
  }
};
</script>

<style scoped>
.imagecontainer {
  height: 200px;
  max-height: 200px;
}
</style>
